<template >
  <section class="big-title">
    <h1 class="font--semibold big-title__main">{{title}}</h1>
  </section>
</template>

<script >
import titleData from "@/assets/json-data/twelveByOneData";
export default {
  name: "big-title",
  props: [],
  mounted() {},
  data() {
    return {
      title: titleData.title
    };
  },
  methods: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.big-title {
  width: 100%;
  &__main {
    font-size: 200px;
    text-transform: uppercase;
  }
}
</style>
